import styled from "@emotion/styled";
import { Box } from "@mui/material";

type AnimatedProps = {
  delay: number;
  isNewlyGenerated?: boolean;
};

export const AnimatedGameImage = styled(Box)<AnimatedProps>`
  opacity: ${({ isNewlyGenerated }) => (isNewlyGenerated ? 0 : 1)};
  transform: ${({ isNewlyGenerated }) =>
    isNewlyGenerated ? "translateX(-20px)" : "none"};
  animation: ${({ isNewlyGenerated, delay }) =>
    isNewlyGenerated
      ? `fadeInSlide 0.7s ease-in-out ${4.8 + delay * 0.8}s forwards`
      : "none"};

  @keyframes fadeInSlide {
    0% {
      opacity: 0;
      transform: translateX(-20px);
    }
    40% {
      opacity: 0.3;
    }
    80% {
      opacity: 0.7;
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

export const AnimatedGameInfo = styled(Box)<AnimatedProps>`
  & .MuiTypography-root {
    overflow: hidden;
    white-space: nowrap;
    width: ${({ isNewlyGenerated }) => (isNewlyGenerated ? "0" : "100%")};
    visibility: ${({ isNewlyGenerated }) =>
      isNewlyGenerated ? "hidden" : "visible"};

    &:nth-of-type(1) {
      animation: ${({ isNewlyGenerated, delay }) =>
        isNewlyGenerated
          ? `typing 0.7s steps(40, end) ${4.8 + delay * 0.8}s forwards`
          : "none"};
    }

    &:nth-of-type(2) {
      animation: ${({ isNewlyGenerated, delay }) =>
        isNewlyGenerated
          ? `typing 0.7s steps(40, end) ${5.1 + delay * 0.8}s forwards`
          : "none"};
    }
  }

  @keyframes typing {
    0% {
      width: 0;
      visibility: visible;
    }
    100% {
      width: 100%;
      visibility: visible;
    }
  }
`;
